const RenderObject = ({ obj = {} }) => {
  if (!obj || Object.keys(obj).length === 0) return "";

  return Object.entries(obj).map(([key, value]) => {
    return <div key={key}>{`${key}: ${value}`}</div>;
  });
};

export default RenderObject;
